// // src/Footer.js
// import React from "react";
// import {
//   FaFacebookF,
//   FaYoutube,
//   FaLinkedinIn,
//   FaTwitter,
// } from "react-icons/fa";
// import Newsletter from "../Newsletter/Newsletter";
// import App from "../Apps/DownloadApp";


// const Footer = () => {

//   return (
//     <div className="w-full">
//       <div className="relative top-20">
//         <div className="flex flex-col mx-4 sm:flex-row gap-4 justify-center item-center md:mx-4">
//           <Newsletter />
//           <App />
//         </div>
//       </div>
//       <div className="w-full bg-[#095D7E] text-white pt-12">
//         <div className="container mx-auto">
//           <footer className=" flex justify-center ">
//             <div className="">
//               <div className="flex flex-col lg:flex-row justify-between px-4 pt-20 pb-10">
//                 {/* Logo and Social Media Icons */}
//                 <div className="">
//                   <h2 className="text-xl font-bold mb-2 text-[40px]">mediiapp </h2>
//                   <h2 className="text-xl font-bold mb-2  text-[40px]">
//                     {" "}
//                     ENTERPRISE
//                   </h2>
//                   {/* <div className="flex space-x-4 text-2xl pt-4">

//                     <FaFacebookF onClick={()=>navigate("/facebook.com")}  className="cursor-pointer hover:text-gray-300 text-[15px]" />
//                     <FaYoutube  onClick={()=>navigate("/facebook.com")} className="cursor-pointer hover:text-gray-300 text-[15px]" />
//                     <FaLinkedinIn  onClick={()=>navigate("/in.linkedin.com/")} className="cursor-pointer hover:text-gray-300 text-[15px]" />
//                     <FaTwitter  onClick={()=>navigate("/facebook.com")} className="cursor-pointer hover:text-gray-300 text-[15px]" />
//                   </div> */}

//                   <div className="flex space-x-4 text-2xl pt-4">
//                     <a
//                       href="https://www.facebook.com"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                     >
//                       <FaFacebookF className="cursor-pointer hover:text-gray-300 text-[15px]" />
//                     </a>

//                     <a
//                       href="https://www.youtube.com"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                     >
//                       <FaYoutube className="cursor-pointer hover:text-gray-300 text-[15px]" />
//                     </a>

//                     <a
//                       href="https://www.linkedin.com"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                     >
//                       <FaLinkedinIn className="cursor-pointer hover:text-gray-300 text-[15px]" />
//                     </a>

//                     <a
//                       href="https://twitter.com"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                     >
//                       <FaTwitter className="cursor-pointer hover:text-gray-300 text-[15px]" />
//                     </a>
//                   </div>
//                 </div>
//                 <div className="mb-6 lg:mb-0 lg:w-1/3 lg:px-12 text-center lg:text-left">
//                   <p>
//                     Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
//                     do eiusmod tempor incididunt ut labore et dolore magna
//                     aliqua.
//                   </p>
//                   <p className="pt-2">
//                     Ut enim ad minim veniam, quis nostrud exercitation ullamco
//                     laboris nisi ut aliquip ex ea commodo consequat.
//                   </p>
//                 </div>

//                 <div className="flex flex-col lg:flex-row justify-around lg:justify-end flex-1">
//                   <div className="flex-1 flex-col mb-6 lg:mb-0 text-center lg:text-left">
//                     <h3 className="font-semibold mb-2 text-[16px]">Home</h3>
//                     <button href="#" className="block mb-1 hover:underline">
//                       Lorem ipsum
//                     </button>
//                     <button href="#" className="block mb-1 hover:underline">
//                       Lorem ipsum
//                     </button>
//                     <button href="#" className="block mb-1 hover:underline">
//                       Lorem ipsum
//                     </button>
//                     <button href="#" className="block mb-1 hover:underline">
//                       Lorem ipsum
//                     </button>
//                   </div>
//                   <div className="flex-1 flex-col mb-6 lg:mb-0 text-center lg:text-left">
//                     <h3 className="font-semibold mb-2 text-[16px]">
//                       Kidney Medicines
//                     </h3>
//                     <button className="block mb-1 hover:underline">
//                       Lorem ipsum
//                     </button>
//                     <button href="#" className="block mb-1 hover:underline">
//                       Lorem ipsum
//                     </button>
//                     <button href="#" className="block mb-1 hover:underline">
//                       Lorem ipsum
//                     </button>
//                     <button href="#" className="block mb-1 hover:underline">
//                       Lorem ipsum
//                     </button>
//                   </div>
//                   <div className="flex-1 flex-col mb-6 lg:mb-0 text-center lg:text-left">
//                     <h3 className="font-semibold mb-2 text-[16px]">FAQs</h3>
//                     <button href="#" className="block mb-1 hover:underline">
//                       Lorem ipsum
//                     </button>
//                     <button href="#" className="block mb-1 hover:underline">
//                       Lorem ipsum
//                     </button>
//                     <button href="#" className="block mb-1 hover:underline">
//                       Lorem ipsum
//                     </button>
//                     <button href="#" className="block mb-1 hover:underline">
//                       Lorem ipsum
//                     </button>
//                   </div>
//                   <div className="flex-1 flex-col mb-6 lg:mb-0 text-center lg:text-left">
//                     <h3 className="font-semibold mb-2 text-[16px]">
//                       Contact Us
//                     </h3>
//                     <button href="#" className="block mb-1 hover:underline">
//                       Lorem ipsum
//                     </button>
//                     <button href="#" className="block mb-1 hover:underline">
//                       Lorem ipsum
//                     </button>
//                     <button href="#" className="block mb-1 hover:underline">
//                       Lorem ipsum
//                     </button>
//                     <button href="#" className="block mb-1 hover:underline">
//                       Lorem ipsum
//                     </button>
//                   </div>
//                 </div>
//               </div>
//               <div
//                 className="text-center border-t border-[#F1F9FF]
//  py-4"
//               >
//                 <p>Copyright @sdlcCorp 2024</p>
//               </div>
//             </div>
//           </footer>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Footer;
import React, { useEffect, useState } from "react";
import {
  FaFacebookF,
  FaYoutube,
  FaTwitter,
  FaLinkedinIn,
  FaEnvelope,
  FaPhoneAlt,
  FaCheck,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { apiPOST } from '../../utilities/apiHelpers';
import { toast } from "react-toastify";

const Footer = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null); 


  const socialLinks = [
  { Icon: FaFacebookF, url: 'https://facebook.com' },
  { Icon: FaYoutube, url: 'https://youtube.com' },
  { Icon: FaTwitter, url: 'https://twitter.com' },
  { Icon: FaLinkedinIn, url: 'https://www.linkedin.com/in/mediiappindia/' },
];

  // Detect user on mount
  useEffect(() => {
    // NOTE: Change "user" to whatever key you use in your login logic (e.g., "userInfo")
    const storedData = localStorage.getItem("user");
    if (storedData) {
      const parsedUser = JSON.parse(storedData);
      setUser(parsedUser);
      setEmail(parsedUser.email); // Auto-fill the field
    }
  }, []);

  const handleSubscribe = async () => {
    if (!email) {
      toast.error("Please enter your email");
      return;
    }

    // --- CASE 1: LOGGED IN VALIDATION ---
    if (user && user.email) {
      if (user.email.toLowerCase() !== email.toLowerCase()) {
        toast.error(`You are logged in as ${user.email}. Please use this email.`);
        return; // This prevents the API call if they typed something else
      }
    }

    try {
      setLoading(true);
      // Payload for the API
      const payload = { email };

      const response = await apiPOST("/v1/email-subscribe/add", payload);

      // Check for success (adjust based on your apiPOST structure)
      if (response?.data?.status || response?.status === 201) {
        toast.success(response?.data?.message || "Subscribed successfully!");
        // --- CASE 2: LOGGED OUT (GUEST) ---
        if (!user) {
          setEmail(""); // Clear for guests
        }
      } else {
        toast.error(response?.data?.data || "Subscription failed");
      }
    } catch (error) {
      console.error("Subscription Error:", error);
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

 const handleProductNavigationHome = () => {
    navigate("/");
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Use "smooth" for a rolling effect or "auto" for instant
    });
  };

  const handleProductNavigation = () => {
    navigate("/products");
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Use "smooth" for a rolling effect or "auto" for instant
    });
  };

  const handleMyOrder = () => {
    navigate("/orders");
    window.scrollTo({ 
      top: 0,
      behavior: "smooth", // Use "smooth" for a rolling effect or "auto" for instant
    });
  };

  const handleShippingDelivery = () => {
    navigate("/shipping-delivery");
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Use "smooth" for a rolling effect or "auto" for instant
    });
  };
  

  const handleCancellationRefund = () => {
    navigate("/cancellation-refund  ");
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Use "smooth" for a rolling effect or "auto" for instant
    });
  };

    const handlePrivacyPolicy = () => {
      navigate("/privacy-policy");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };

  const handleTermsConditions = () => {
    navigate("/terms-conditions");
    window.scrollTo({ 
      top: 0,
      behavior: "smooth", // Use "smooth" for a rolling effect or "auto" for instant
    });
  }

  const handleFNqNavigation = () => {
    navigate("/faqs");
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Use "smooth" for a rolling effect or "auto" for instant
    });
  };

  const handleContactUsNavigation = () => {
    navigate("/contact-us");
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Use "smooth" for a rolling effect or "auto" for instant
    });
  };
  const handleAboutUsNavigation = () => {
    navigate("/about-us");
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Use "smooth" for a rolling effect or "auto" for instant
    });
  };

  const handleProduct = () => {
    navigate("/upload-prescription");
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Use "smooth" for a rolling effect or "auto" for instant
    });
  };



  return (
    <div className="w-full font-sans">
      {/* --- FLOATING NEWSLETTER & APP SECTION --- */}
      <div className="relative z-10 -mb-28 px-4">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">

          {/* Newsletter Card */}
          <div className="bg-[#F1F9FF] p-10 rounded-xl shadow-sm border border-blue-50 flex flex-col items-center justify-center text-center">
            <h2 className="text-[32px] font-bold text-[#1D2939] mb-4">Join our newsletter</h2>
            <p className="text-[#475467] text-[16px] mb-8 max-w-sm">
              Join over half a million vitamin lovers and get our latest deals, articles, and resources!
            </p>
            <div className="relative w-full max-w-md">
              <input
                type="email"
                placeholder="Enter your Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full py-4 px-6 rounded-full border border-gray-200 outline-none text-gray-600 shadow-inner"
              />
              <button
                onClick={handleSubscribe}
                disabled={loading}
                className="absolute right-2 top-2 bottom-2 bg-[#149184] text-white px-8 rounded-full font-semibold hover:bg-[#0f6e64] transition-all disabled:opacity-60"
              >
                {loading ? "Subscribing..." : "Subscribe"}
              </button>
            </div>
          </div>

          {/* Download App Card */}
          <div className="bg-[#E9F9E9] p-10 rounded-xl shadow-sm border border-green-50 flex flex-col items-center justify-center text-center">
            <h2 className="text-[32px] font-bold text-[#1D2939] mb-4">Download app</h2>
            <p className="text-[#475467] text-[16px] mb-8">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed aliqua.
            </p>
            <div className="flex flex-col lg:flex-row gap-4">
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Google Play"
                className="h-14 cursor-pointer hover:opacity-80 transition-opacity"
                onClick={() => window.open("https://play.google.com/store/apps/details?id=com.mayaenterprise.app", "_blank", "noopener,noreferrer")}
              />
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
                alt="App Store"
                className="h-14 cursor-pointer hover:opacity-80 transition-opacity"
                onClick={() => window.open("https://apps.apple.com/in/app/mediiapp/id6759659803", "_blank", "noopener,noreferrer")}
              />
            </div>
          </div>
        </div>
      </div>

      {/* --- MAIN DARK FOOTER BODY --- */}
      <div className="bg-[#074D61] text-white pt-48 pb-6">
        <div className="max-w-7xl mx-auto ">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 border-b border-white/10 pb-12">

            {/* 1. Brand Section (4 cols) */}
            <div className="lg:col-span-3 space-y-6">
              <div>
                <h2 className="text-[28px] font-bold leading-tight text-[#0d9488]">mediiapp</h2>
                {/* <h2 className="text-[28px] font-bold leading-tight uppercase">Enterprise</h2> */}
              </div>
              <p className="text-[14px] leading-relaxed opacity-90">
                mediiapp is a trusted online medicine platform specializing in kidney care and essential medicines.
              </p>
              <p className="text-[14px] leading-relaxed opacity-90">
                All medicines are sourced from licensed pharmacies and delivered with safety and care.
              </p>
              {/* Circular Social Icons exactly like image */}
              <div className="flex space-x-3 pt-2">
  {socialLinks.map(({ Icon, url }, idx) => (
    <div 
      key={idx} 
      onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
      className="bg-white/20 p-2.5 rounded-full cursor-pointer hover:bg-white/40 transition-colors"
    >
      <Icon className="text-[14px]" />
    </div>
  ))}
</div>
            </div>

            {/* 2. Quick Links (2 cols) */}
            <div className="lg:col-span-2 ">
              <h3 className="text-[18px] font-bold mb-6">Quick Links</h3>
              <ul className="space-y-3 text-[14px] opacity-80">
                <li onClick={handleProductNavigationHome} className="hover:text-white  cursor-pointer">Home</li>
                <li onClick={handleProductNavigation} className="hover:text-white  cursor-pointer">Kidney Medicines</li>
                <li onClick={handleFNqNavigation} className="hover:text-white  cursor-pointer">FAQs</li>
                <li onClick={handleContactUsNavigation} className="hover:text-white  cursor-pointer">Contact Us</li>
                <li onClick={handleAboutUsNavigation} className="hover:text-white  cursor-pointer">About Us</li>
                <li onClick={handleProduct} className="hover:text-white  cursor-pointer pt-2">Upload Prescription</li>
                <li onClick={handleMyOrder} className="hover:text-white  cursor-pointer">My Orders</li>
                {/* <li onClick={handlePrivacyPolicy} className="hover:text-white  cursor-pointer">Privacy Policy</li>
                <li onClick={handleTermsConditions} className="hover:text-white  cursor-pointer">Terms & Conditions</li>
                <li onClick={handleCancellationRefund} className="hover:text-white  cursor-pointer">Cancellation & Refund Policy</li>
                <li onClick={handleShippingDelivery} className="hover:text-white  cursor-pointer">Shipping & Delivery Policy</li> */}
              </ul>
            </div>

            {/* 3. Medicines (2 cols) */}
            <div className="lg:col-span-2">
              <h3 className="text-[18px] font-bold mb-6">Policies</h3>
              <ul className="space-y-3 text-[14px] opacity-80">
                <li onClick={handlePrivacyPolicy} className="hover:text-white  cursor-pointer">Privacy Policy</li>
                <li onClick={handleTermsConditions} className="hover:text-white  cursor-pointer">Terms & Conditions</li>
                <li onClick={handleCancellationRefund} className="hover:text-white  cursor-pointer">Cancellation & Refund Policy</li>
                <li onClick={handleShippingDelivery} className="hover:text-white  cursor-pointer">Shipping & Delivery Policy</li>
              </ul>
            </div>

            {/* 4. Support & Disclaimer (5 cols) */}
            <div className="lg:col-span-5 space-y-8">
              <div className="flex flex-col md:flex-row justify-between gap-6">
                <div className="space-y-3">
                  <h3 className="text-[18px] font-bold">Customer Support</h3>
                  <p className="flex items-center gap-2 text-[14px] opacity-90">
                    <FaEnvelope className="text-[#88C5D8]" /> Mediiappindia@gmail.com
                  </p>
                  <p className="flex items-center gap-2 text-[14px] opacity-90">
                    <FaPhoneAlt className="text-[#88C5D8]" /> +91 85880 55556
                  </p>
                </div>
                <div className="space-y-3">
                  <h3 className="text-[18px] font-bold">Sales Enquiries</h3>
                  <p className="flex items-center gap-2 text-[14px] opacity-90">
                    <FaEnvelope className="text-[#88C5D8]" /> Mediiappindia@gmail.com
                  </p>
                  <p className="flex items-center gap-2 text-[14px] opacity-90">
                    <FaPhoneAlt className="text-[#88C5D8]" /> +91 9873320785
                  </p>
                </div>
              </div>

              {/* Specific Medical Disclaimer Box from Screenshot */}
              <div className="bg-[#F1F9FF]/10 p-5 rounded-lg border border-white/10 backdrop-blur-sm">
                <h4 className="font-bold text-[16px] mb-2">Medical Disclaimer:</h4>
                <p className="text-[13px] leading-relaxed opacity-80">
                  The information provided on this platform is for general awareness only and is not a substitute for professional medical advice. Always consult a qualified doctor before consuming any medicine.
                </p>
              </div>
            </div>
          </div>

          {/* --- BOTTOM STRIP --- */}
          <div className="pt-8 flex flex-col items-center space-y-4">
            <div className="flex flex-col md:flex-row items-center gap-2 text-[14px] opacity-90 font-medium">
              <p>© 2024 <span className="uppercase">MEDiiAPP</span>. All Rights Reserved.</p>
              <span className="hidden md:block">|</span>
              {/* <p>Powered by SDLC Corp</p> */}
            </div>

            {/* The Checkmark Badges exactly like the image */}
            <div className="flex flex-wrap justify-center gap-6 text-[13px] font-semibold">
              <span className="flex items-center gap-2"><FaCheck className="text-[#2DD4BF]" /> 100% Genuine Medicines</span>
              <span className="flex items-center gap-2"><FaCheck className="text-[#2DD4BF]" /> Secure Payments</span>
              <span className="flex items-center gap-2"><FaCheck className="text-[#2DD4BF]" /> Licensed Pharmacy Partners</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;